import logo from './logo';
import printer from './printer';
import help from './help';
import hamburger from './hamburger';
import photo from './photo';
import heart from './heart';
import heartfavorite from './heartfavorite';
import home from './home';
import rightarrow from './rightarrow';
import backArrow from './back_arrow';
import arrowLeft from './arrow-left';
import arrowRight from './arrow-right';
import arrowDown from './arrow-down';
import back from './back';
import forward from './forward';
import arrowUp from './arrow-up';
import arrowDownTrend from './arrowDownTrend';
import arrowUpTrend from './arrowUpTrend';
import location from './location';
import plus from './plus';
import minus from './minus';
import promarketplace from './promarketplace';
import bulb from './bulb';
import message from './message';
import calendar from './calendar';
import calendarblue from './calendarblue';
import chat from './chat';
import close from './close';
import stepback from './stepback';
import edit from './edit';
import navcal from './navcal';
import navmessage from './navmessage';
import check from './check';
import circleIcon from './circle';
import circleCheckNew from './circle-check-new';
import circlecheck from './circlecheck';
import savings from './savings';
import smart from './smart';
import easy from './easy';
import transparency from './transparency';
import savesearch from './savesearch';
import bed from './bed';
import bath from './bath';
import squarefeet from './squarefeet';
import SoldListingPin from './sold-listing-pin';
import SoldListingPinWhite from './sold-listing-pin-white';
import property from './property';
import parking from './parking';
import lotsize from './lotsize';
import yearbuilt from './yearbuilt';
import facebook from './facebook';
import twitter from './twitter';
import bodepin from './bodepin';
import mlsPin from './mls-pin';
import bodewhitepin from './bodewhitepin';
import bulletCheckmark from './bullet-checkmark';
import account from './account';
import mail from './mail';
import myabode from './myabode';
import realtor from './realtor';
import loupe from './loupe';
import photography from './photography';
import generalcontractor from './generalContractor';
import editlisting from './editlisting';
import share from './share';
import heat from './heat';
import price from './price';
import cooling from './cooling';
import hoa from './hoa';
import offers from './offers';
import heartoutline from './heartoutline';
import link from './link';
import externalLink from './external-link';
import faqs from './FAQs';
import uploads from './uploads';
import profile from './profile';
import portal from './portal';
import photographer from './photographer';
import measuring from './measuring';
import inspection from './inspection';
import generalcontracting from './generalcontracting';
import staging from './staging';
import legal from './legal';
import trash from './trash';
import servicerequest from './serviceRequest';
import heating from './heating';
import faq from './faq';
import trashGoogleMap from './trash_google_map';
import forum from './forum';
import camera from './camera';
import clock from './clock';
import clockGrey from './clockgrey';
import viewing from './viewing';
import information from './information';
import edit2 from './edit2';
import marketData from './marketData';
import mortgageAsset from './mortgageAsset';
import forsalebode from './forsalebode';
import listingactive from './listingactive';
import listingsold from './listingsold';
import messageWhite from './message-white';
import linkedInCircle from './linkedincircle';
import twitterCircle from './twittercircle';
import facebookCircle from './facebookcircle';
import phone from './phone';
import calendaryear from './calendaryear';
import sharebox from './sharebox';
import proStorage from './pro-storage';
import proAppraisal from './pro-appraisal';
import proCleaning from './pro-cleaning';
import proConsultancy from './pro-consultancy';
import proDeckingFencing from './pro-decking-fencing';
import proDrywall from './pro-drywall';
import proElectrical from './pro-electrical';
import proEngineering from './pro-engineering';
import proFlooring from './pro-flooring';
import proHandyServices from './pro-handy-services';
import proHomeInspection from './pro-home-inspection';
import proHvac from './pro-HVAC';
import proInsulation from './pro-insulation';
import proInteriorDesign from './pro-interior-design';
import proLandscaping from './pro-landscaping';
import proLegal from './pro-legal';
import proLocalFurnishings from './pro-local-furnishings';
import proMeasurements from './pro-measurements';
import proMortgage from './pro-mortgage';
import proMoving from './pro-moving';
import proOrganization from './pro-organization';
import proPainting from './pro-painting';
import proPhotography from './pro-photography';
import proPlumbing from './pro-plumbing';
import proRenovationsAdditions from './pro-renovations-additions';
import proRoofing from './pro-roofing';
import proSmartHome from './pro-smart-home';
import proStaging from './pro-staging';
import paperclip from './paperclip';
import garage from './garage';
import sticker from './sticker';
import zoning from './zoning';
import download from './download';
import percentage from './percentage';
import house from './house';
import hourglass from './hourglass';
import averageViewing from './average-viewing';
import house2 from './house2';
import chevronLeft from './chevron-left';
import chevronRight from './chevron-right';
import barChart from './bar-chart';
import designService from './design-service';
import handshake from './handshake';
import quotes from './quotes';
import spinner from './spinner';
import info from './info';
import arrowRightLight from './arrow-right-light';
import triangleInfo from './triangle-info';
import circleInfo from './circle-info';

/**
 * Expose all icons needed bu vuetify.
 *
 * @type {Object}
 * @private
 */

export default {
  logo: { component: logo },
  printer: { component: printer },
  hamburger: { component: hamburger },
  photo: { component: photo },
  help: { component: help },
  heart: { component: heart },
  heartfavorite: { component: heartfavorite },
  home: { component: home },
  backArrow: { component: backArrow },
  arrowLeft: { component: arrowLeft },
  arrowRight: { component: arrowRight },
  arrowDown: { component: arrowDown },
  arrowUp: { component: arrowUp },
  back: { component: back },
  forward: { component: forward },
  arrowDownTrend: { component: arrowDownTrend },
  arrowUpTrend: { component: arrowUpTrend },
  location: { component: location },
  plus: { component: plus },
  minus: { component: minus },
  rightarrow: { component: rightarrow },
  promarketplace: { component: promarketplace },
  bulb: { component: bulb },
  message: { component: message },
  calendar: { component: calendar },
  calendarblue: { component: calendarblue },
  chat: { component: chat },
  close: { component: close },
  stepback: { component: stepback },
  edit: { component: edit },
  navcal: { component: navcal },
  navmessage: { component: navmessage },
  circleIcon: { component: circleIcon },
  circlecheck: { component: circlecheck },
  bulletCheckmark: { component: bulletCheckmark },
  savings: { component: savings },
  smart: { component: smart },
  easy: { component: easy },
  transparency: { component: transparency },
  savesearch: { component: savesearch },
  bed: { component: bed },
  bath: { component: bath },
  squarefeet: { component: squarefeet },
  soldListingPin: { component: SoldListingPin },
  soldListingPinWhite: { component: SoldListingPinWhite },
  property: { component: property },
  parking: { component: parking },
  lotsize: { component: lotsize },
  yearbuilt: { component: yearbuilt },
  facebook: { component: facebook },
  twitter: { component: twitter },
  bodepin: { component: bodepin },
  mlsPin: { component: mlsPin },
  bodewhitepin: { component: bodewhitepin },
  account: { component: account },
  mail: { component: mail },
  myabode: { component: myabode },
  realtor: { component: realtor },
  loupe: { component: loupe },
  photography: { component: photography },
  editlisting: { component: editlisting },
  share: { component: share },
  camera: { component: camera },
  heartoutline: { component: heartoutline },
  heat: { component: heat },
  price: { component: price },
  clock: { component: clock },
  clockGrey: { component: clockGrey },
  cooling: { component: cooling },
  hoa: { component: hoa },
  offers: { component: offers },
  generalcontractor: { component: generalcontractor },
  link: { component: link },
  externalLink: { component: externalLink },
  forum: { component: forum },
  faqs: { component: faqs },
  uploads: { component: uploads },
  profile: { component: profile },
  portal: { component: portal },
  trash: { component: trash },
  photographer: { component: photographer },
  inspection: { component: inspection },
  generalcontracting: { component: generalcontracting },
  legal: { component: legal },
  staging: { component: staging },
  measuring: { component: measuring },
  servicerequest: { component: servicerequest },
  heating: { component: heating },
  faq: { component: faq },
  trashGoogleMap: { component: trashGoogleMap },
  viewing: { component: viewing },
  information: { component: information },
  edit2: { component: edit2 },
  marketData: { component: marketData },
  mortgageAsset: { component: mortgageAsset },
  forsalebode: { component: forsalebode },
  listingactive: { component: listingactive },
  listingsold: { component: listingsold },
  messageWhite: { component: messageWhite },
  linkedInCircle: { component: linkedInCircle },
  twitterCircle: { component: twitterCircle },
  facebookCircle: { component: facebookCircle },
  phone: { component: phone },
  calendaryear: { component: calendaryear },
  sharebox: { component: sharebox },
  proStorage: { component: proStorage },
  proAppraisal: { component: proAppraisal },
  proCleaning: { component: proCleaning },
  proConsultancy: { component: proConsultancy },
  proDeckingFencing: { component: proDeckingFencing },
  proDrywall: { component: proDrywall },
  proElectrical: { component: proElectrical },
  proEngineering: { component: proEngineering },
  proFlooring: { component: proFlooring },
  proHandyServices: { component: proHandyServices },
  proHomeInspection: { component: proHomeInspection },
  proHvac: { component: proHvac },
  proInsulation: { component: proInsulation },
  proInteriorDesign: { component: proInteriorDesign },
  proLandscaping: { component: proLandscaping },
  proLegal: { component: proLegal },
  proLocalFurnishings: { component: proLocalFurnishings },
  proMeasurements: { component: proMeasurements },
  proMortgage: { component: proMortgage },
  proMoving: { component: proMoving },
  proOrganization: { component: proOrganization },
  proPainting: { component: proPainting },
  proPhotography: { component: proPhotography },
  proPlumbing: { component: proPlumbing },
  proRenovationsAdditions: { component: proRenovationsAdditions },
  proRoofing: { component: proRoofing },
  proSmartHome: { component: proSmartHome },
  proStaging: { component: proStaging },
  paperclip: { component: paperclip },
  garage: { component: garage },
  sticker: { component: sticker },
  download: { component: download },
  zoning: { component: zoning },
  percentage: { component: percentage },
  house: { component: house },
  hourglass: { component: hourglass },
  averageViewing: { component: averageViewing },
  house2: { component: house2 },
  chevronLeft: { component: chevronLeft },
  chevronRight: { component: chevronRight },
  barChart: { component: barChart },
  designService: { component: designService },
  handshake: { component: handshake },
  quotes: { component: quotes },
  check: { component: check },
  spinner: { component: spinner },
  info: { component: info },
  arrowRightLight: { component: arrowRightLight },
  circleCheckNew: { component: circleCheckNew },
  triangleInfo: { component: triangleInfo },
  circleInfo: { component: circleInfo },
};
